import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter, IAddPolicy, PolicyID } from '@app/models';

class PoliciesAuthService {
    readonly apiBase: string = '/api/directory/Policies';

    getPoliciesAuth(orderBy: string, asc: string, top: number, skip: number, isReset: boolean, filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(this.apiBase, {
            params: {
                $orderBy: orderBy + ' ' + asc,
                $top: top,
                $skip: skip,
                $count: isReset,
                ...(filters ? { $filter: manageFilters(filters) } : { $filter: manageFilters([]) })
            }
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    deleteAuthPolicies(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/DeletePolicies`;

        return apiService.post(apiUrl,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    getAuthPolicies(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}`,
            { params: {
                    $orderBy: 'DisplayName asc',
                }, onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    getAuthPolicyDefaults(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/Defaults`,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    addPolicy(policy: IAddPolicy, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}`, policy,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    updatePolicy(policyId: PolicyID, policy: IAddPolicy, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.patch(`${this.apiBase}(${policyId})`, policy,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    getPolicyDetails(policyId: PolicyID, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}(${policyId})`,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }
}

export const policiesAuthService = new PoliciesAuthService();
